// extracted by mini-css-extract-plugin
export default {"gridColDiv":"StyleTable_gridColDiv__ziqDu","gridRowDiv":"StyleTable_gridRowDiv__TdNEv","textWithInput":"StyleTable_textWithInput__i1sab","table":"StyleTable_table__Q2h2c"};